
/* AKS QA API URLs*/
const BASE_URL = "https://xbpqa-uk-rtp.exela.global";
const APIVERSION = "V2.0.0"; //V2.0.0 //V1.0
const USER_API = `${BASE_URL}/apis/requesttopay/${APIVERSION}/app/user`;
const NATIVE_APP_URL = "https://xbppayerqa-uk.exela.global"; 
const MIXPANEL_TOKEN = '7e518a89c7a82cf730e5647be319c2da';
const GOOGLE_ANALYTICS_TOKEN = 'G-QS3G6MWWWW';
const RESET_PWD_LINK = "https://xbpqa-uk-oauth.exela.global/Account/ResetPassword";
/** Firebase config: Start */
const FIREBASE_CONFIG = "eyJhcGlLZXkiOiJBSXphU3lEdTFWUVVOSVpaNDlWcm5ZdzA1WDVqTE5hVko0Nk5BQUUiLCJhdXRoRG9tYWluIjoieGJwLXBheS11ay5maXJlYmFzZWFwcC5jb20iLCJwcm9qZWN0SWQiOiJ4YnAtcGF5LXVrIiwic3RvcmFnZUJ1Y2tldCI6InhicC1wYXktdWsuYXBwc3BvdC5jb20iLCJtZXNzYWdpbmdTZW5kZXJJZCI6IjMzMDk5MTkxMzk3MCIsImFwcElkIjoiMTozMzA5OTE5MTM5NzA6d2ViOjI4ZWM4MGZkYjU0ODQ0ZGNkOGI5NmIiLCJtZWFzdXJlbWVudElkIjoiRy0wTlJYM0pQMEIwIn0=";

const FIREBASE_VAPID_KEY = "BCoKc8syJ3TV2vQ5OrKac6LAbcBuOv2yVScRuBABIGGo3mQaf_jc0zvRbEZAmd0Pk0ZeE8NJykxg4oYJ-Sr9vGE";
/** Firebase config: End */

export {
    BASE_URL, USER_API, NATIVE_APP_URL, MIXPANEL_TOKEN, GOOGLE_ANALYTICS_TOKEN, RESET_PWD_LINK, FIREBASE_CONFIG, FIREBASE_VAPID_KEY
}